/* Lightweight display-only Title Case for approved customer-facing labels. */
(function () {
  'use strict';

  var PROTECTED = {
    gst: 'GST', mrp: 'MRP', fssai: 'FSSAI', hsn: 'HSN', cod: 'COD',
    faq: 'FAQ', faqs: 'FAQs', seo: 'SEO', g: 'g', kg: 'kg', ml: 'ml',
    govindjee: 'GovindJee'
  };
  var MINOR = {
    a: 1, an: 1, and: 1, as: 1, at: 1, but: 1, by: 1, for: 1,
    from: 1, in: 1, nor: 1, of: 1, on: 1, or: 1, the: 1, to: 1, with: 1
  };
  var WORD = /[A-Za-z]+(?:['’][A-Za-z]+)*/g;
  var MEASURE = /^[\s₹$]*[\d.,]+\s*(g|gm|gms|gr|gram|grams|kg|kgs|mg|ml|l|ltr|ltrs|litre|litres|liter|liters|pc|pcs|piece|pieces|pack|packs|packet|packets|box|pouch|can|jar|tin|bottle|%|x|\+)?\s*$/i;
  var SKIP = [
    'script', 'style', 'noscript', 'svg', 'input', 'textarea', 'select',
    'template', '[contenteditable]', '.rte', '.gj-nutrition',
    '.gj-collection-description', '.price', '[data-product-price]',
    's[data-compare-price]', '.gj-mini-variant', '.product-tile__pack-size',
    '[data-current-variant]', '.sr-only', '.visually-hidden',
    '[x-html*="formatMoney"]', '[x-html*="Price"]',
    '[x-text*="formatMoney"]', '[x-text*="Price"]',
    '[x-text*="countWithText"]'
  ].join(',');
  var TARGET = [
    '.product-tile h3', '.product-block-title h1',
    '.product-block-title h2', '[data-product-title] > p:first-child',
    '.inline-heading-rte', 'main h1', '.push-btn__surface',
    'nav[role="navigation"] a', '.sidebar-nav a', 'footer a', 'footer h2',
    '[role="tab"]', 'button[aria-controls^="panel-"]',
    'button[aria-controls^="accordion"]', '#left-drawer-slot h1',
    '#left-drawer-slot h2', '#right-drawer-slot h1',
    '#right-drawer-slot h2',
    '#predictive-search-results .showcase-tile__title'
  ].join(',');

  function titleCase(value) {
    var words = value.match(WORD) || [];
    var position = 0;
    return value.replace(WORD, function (word) {
      var lower = word.toLowerCase();
      var first = position === 0;
      var last = position === words.length - 1;
      position += 1;
      if (Object.prototype.hasOwnProperty.call(PROTECTED, lower)) {
        return PROTECTED[lower];
      }
      if (!first && !last && MINOR[lower]) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    });
  }

  function transform(element) {
    if (!element || element.closest(SKIP)) return;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (
        node.parentElement &&
        !node.parentElement.closest(SKIP) &&
        /[A-Za-z]/.test(node.nodeValue) &&
        !MEASURE.test(node.nodeValue.trim())
      ) {
        nodes.push(node);
      }
    }
    nodes.forEach(function (textNode) {
      var value = titleCase(textNode.nodeValue);
      if (value !== textNode.nodeValue) textNode.nodeValue = value;
    });
  }

  function apply(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches(TARGET)) transform(scope);
    if (!scope.querySelectorAll) return;
    var targets = Array.from(scope.querySelectorAll(TARGET));
    var index = 0;
    function batch() {
      var stop = Math.min(index + 8, targets.length);
      while (index < stop) transform(targets[index++]);
      if (index < targets.length) {
        if (window.requestIdleCallback) window.requestIdleCallback(batch, { timeout: 1500 });
        else window.setTimeout(batch, 0);
      }
    }
    batch();
  }

  function init() {
    apply(document);
    /* Theme-editor updates are explicit; avoid a permanent document observer. */
    document.addEventListener('shopify:section:load', function (event) {
      apply(event.target);
    });
  }

  function schedule() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(init, { timeout: 1500 });
    } else {
      window.setTimeout(init, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
